import MainButton from '@/components/ui/custom/buttons/MainButton';
import ModalDisable from '@/components/ui/custom/modals/ModalDisable';
import useSafePortal from '@/data/hook/useSafePortal';
import useToggle from '@/data/hook/useToggle';
import { deleteProject } from '@/data/services/projectServices';
import { projectsQuerykeys } from '@/data/services/querykeys';
import { Project } from '@/models/Project';
import { getErrorMessage } from '@/utils/getErrorMessage';
import alert from '@/utils/shared/alert';
import { TrashIcon } from '@heroicons/react/24/outline';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Fragment } from 'react/jsx-runtime';

const ProjectDelete = ({ id, title }: Pick<Project, 'id' | 'title'>) => {
  const createSafePortal = useSafePortal();
  const { t } = useTranslation('translation', {
    keyPrefix: 'projects.view',
  });
  const navigate = useNavigate();
  const projectsKey = projectsQuerykeys.list._def;
  const queryClient = useQueryClient();

  const invalidade = async () =>
    await queryClient.invalidateQueries(projectsKey);
  const { open, isOpen, close } = useToggle(false);
  const { mutate: confirmDeleteProject, isLoading: isDeleting } = useMutation(
    deleteProject,
    {
      async onSuccess() {
        await invalidade();
        navigate('/projects');
      },
      onError(error) {
        alert.error(getErrorMessage(error));
      },
    },
  );
  return (
    <Fragment>
      <MainButton
        onClick={open}
        icon={<TrashIcon className="w-4 h-4" />}
        color="warning"
        text={t('deleteProject')}
      />

      {createSafePortal(
        <ModalDisable
          onClickCancel={close}
          onClickConfirm={() => confirmDeleteProject(id)}
          translationString="deleteProject"
          modalType="delete"
          visible={isOpen}
          selectedObjectName={title}
          isRequesting={isDeleting}
        />,
      )}
    </Fragment>
  );
};

export default ProjectDelete;
